
export const scriptTaskName = 'check conditions';
export const startGatewayToScriptTaskConn = 'scriptTaskDataExistenceConn';
export const startGatewayToUserTaskConn = 'userTaskDataExistenceConn';
export const userTaskName = 'Get input';
export const scriptTaskResultVariablePostFix = 'counter';

 export function generateEndGateWayToEndEventExpression(subProcessId: string) {
     return `${subProcessId}_${scriptTaskResultVariablePostFix} == 1`;
 }
 export function generateEndGateWayToUserInputExpression(subProcessId: string) {
     return `${subProcessId}_${scriptTaskResultVariablePostFix} != 1`;
 }
 export function generateCounterName(subProcessId: string) {
     return `${subProcessId}_${scriptTaskResultVariablePostFix}`;
 }

